var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 90,
    viewBox: "0 0 64 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3633_9560)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 90,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 17,
    height: 6,
    rx: 3,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#E0E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#EDF1F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#EDF1F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 44,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9165 77.25H23.0832M16.6665 71.4167L18.9998 73.75M18.9998 73.75L21.3332 71.4167M18.9998 73.75V66.75",
    stroke: "#9CADC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8559 68.63V76H32.3519V73.591H34.2879C35.9819 73.591 37.0159 72.601 37.0159 71.105C37.0159 69.631 35.9819 68.63 34.2879 68.63H30.8559ZM32.3519 72.238V69.983H34.2879C35.0909 69.983 35.5309 70.445 35.5309 71.105C35.5309 71.787 35.0909 72.238 34.2879 72.238H32.3519ZM38.1714 68.63V76H40.8884C43.3194 76 44.9364 74.515 44.9364 72.315C44.9364 70.115 43.3194 68.63 40.8884 68.63H38.1714ZM39.6674 74.647V69.983H40.8884C42.4174 69.983 43.4294 70.885 43.4294 72.315C43.4294 73.745 42.4174 74.647 40.8884 74.647H39.6674ZM47.6381 69.983H51.6421V68.63H46.1421V76H47.6381V73.14H51.2131V71.787H47.6381V69.983Z",
    fill: "#6C819D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 89,
    rx: 5.5,
    stroke: "#E0E7F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3633_9560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 90,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePdf);
export default __webpack_public_path__ + "static/media/mobile-pdf.2d3ee34fc80b58a6521a0de506ad356f.svg";
export { ForwardRef as ReactComponent };